import {
  DetailedHTMLProps,
  forwardRef,
  InputHTMLAttributes,
  LegacyRef,
} from "react";

import styles from "./SingleLineText.module.scss";

type SingleLineTextProps = Omit<
  DetailedHTMLProps<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>,
  "type"
> & {};

/**
 * Text input for single-line entries.
 *
 * Spreads all input props.
 */
const SingleLineText = forwardRef(
  (
    { className, ...props }: SingleLineTextProps,
    ref: LegacyRef<HTMLInputElement> | undefined
  ) => {
    return (
      <input
        ref={ref}
        className={[styles.input, className].join(" ")}
        type="text"
        {...props}
      />
    );
  }
);

export default SingleLineText;
